import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-31df103c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shutddown-info-cntr" }
const _hoisted_2 = { class: "tips" }
const _hoisted_3 = { class: "console-num cm-ui-mb10" }
const _hoisted_4 = { class: "console-desc" }
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    "destroy-on-close": "",
    modelValue: _ctx.modalVisiable,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalVisiable) = $event)),
    "before-close": _ctx.closeModal,
    width: "470px"
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('groupClient.terminalActionModalTitle')), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: _ctx.shutDownTerminal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.submit')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CmSvgIcon, {
          name: "views/dashboard/group/client/modals/_images/client_modal_tip",
          size: 40,
          color: "var(--cm-color-primary)",
          monochrome: ""
        }),
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, _toDisplayString(_ctx.$t('groupClient.shutdownModalSummary', { count: _ctx.count })), 1),
          _createElementVNode("li", _hoisted_4, _toDisplayString(_ctx.$t('groupClient.terminalActionModalUserHint')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}